// extracted by mini-css-extract-plugin
module.exports = {"BackText__button":"BackText__button__1pQFQ","BackText__icon":"BackText__icon__Aap0g"};